<template>
  <div class="main">
    <van-swipe class="my-swipe" :autoplay="3000" indicator-color="white">
      <van-swipe-item v-for="index in commpany.pic" :key="index">
        <img :src="url+commpany.id+'_'+index+'.jpg'" alt="">
      </van-swipe-item>
      <van-swipe-item>
        <img src="../assets/p1.jpg" alt="">
      </van-swipe-item>
      <van-swipe-item><img src="../assets/p3.jpg" alt=""></van-swipe-item>
      <!-- <template #indicator>
        <div class="custom-indicator">{{ current + 1 }}/4</div>
      </template> -->
    </van-swipe>
    <div class="content">
      <div class="header">
        <h3 class="title">{{commpany.commpany}}</h3>
        <van-button
         @click="map" 
         plain 
         round 
         type="info"
         class="mybtn"
         size="mini"
        >
          返回地图
        </van-button>
      </div>
      <div class="tags">
        <div><span>{{commpany.category}}</span><span>行业</span></div>
        <div><span>{{commpany.length}}</span><span>创办时间</span></div>
      </div>
      <div class="ind">
        {{commpany.brief}}
      </div>
      <div class="detail">
        <div class="inlin"> <div class="lable">负责人: <span>{{commpany.name}}</span> </div>  </div>
        <div class="inlin"> <div class="lable">员工人数: <span> {{commpany.num}}人 </span> </div>  </div>
        <div class="lable">办公地址: <span>{{commpany.province+commpany.city+commpany.area+commpany.street}}</span></div>
      </div>
     
    </div>
  </div>
</template>

<script>
export default {
  data(){
    return {
      commpany:{},
      url: ''
    }
  },
  methods: {
    map() {
      this.$router.push({
        name: "main",
        query: {
          lat: this.commpany.lat,
          lng: this.commpany.lng,
          zoom: 14
        }
      })
    }
  },
  created() {
    this.$api.get( `/shops/commpany.php?id=${this.$route.query.id}`)
    .then(res=> {
      this.commpany = res.data
      this.commpany.pic = this.commpany.pic*1
      console.log(this.commpany.pic);
      this.url = `https://jiuye.lqsaa.com/shops/pics/`
    })
  }
}
</script>

<style scoped>
.main {
  height: 100vh;
  font-size: 16px;
  color: black;
}
.my-swipe .van-swipe-item {
  color: #fff;
  font-size: 20px;
  text-align: center;
  height: 200px;
  background-color: #f6f6f6;
}
.my-swipe .van-swipe-item  img{
  height: 100%;
}
.content {
  height: calc(100vh - 140px);
  position: relative;
  top: -10px;
  z-index: 9999;
  background-color: #fff;
  border-radius: 15px 15px 0 0;
}
.header {
  display: flex;
  justify-content: space-between;
  padding:15px
}
.title {
  width: 80%;
}
.tags {
  width: 100%;
  height: 50px;
  display: flex;
  justify-content: space-around;
}
.tags div {
  display: flex;
  flex-direction: column;
  justify-content:center ;
  text-align: center;
  margin: 0 10px;
  min-width: 28%;
  padding: 10px;
  max-width: 58%;
  height: 50px;
  border-radius: 2px;
  background-color: #e7f8ff;
}
.tags div span:first-child {
  color: #1589ff;
}
.tags div span:nth-child(2) {
  color: #75757d
}
.ind {
  margin: 15px;
  font-size: 15px;
  text-align: justify;
  padding-bottom: 5px;
  color: #333;
  border-bottom: 1px solid #e7e7e7;
}
.detail {
  margin: 15px;
  padding-bottom: 5px;
  border-bottom: 1px solid #e7e7e7;
}
.inlin {
  display: inline-block;
  width: 45%;
}
.lable {
  color: #75757d;
  padding: 3px 0;
}
.lable span {
  color: #0c0c42;
}
.gy {
  margin: 15px;
}
.mybtn {
  padding: 0 8px;
}
</style>